import { render, staticRenderFns } from "./_agentTasksModal.vue?vue&type=template&id=31ca2f26"
import script from "./_agentTasksModal.vue?vue&type=script&lang=js"
export * from "./_agentTasksModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports